import React, { Component } from "react";
import { DragSource } from "react-dnd";
import PropTypes from "prop-types";
import ItemTypes from "./ItemTypes";

const areaSource = {
	beginDrag(props) {
		return props;
	},

	// here will be function to manipulate the props
	endDrag(props, monitor) {
		const item = monitor.getItem();
		const dropResult = monitor.getDropResult();	
	}
};

class Area extends Component {
	render() {
		const {connectDragSource, area} = this.props;
		return connectDragSource(
			<div className="skill">{area.name}</div>
		);
	}
}

Area.propTypes = {
	connectDragSource: PropTypes.func.isRequired,
	area: PropTypes.shape({
		name:PropTypes.string,
		value:PropTypes.number
	}).isRequired
};

const collect =connect => ({
	connectDragSource: connect.dragSource(),
});

export default DragSource(ItemTypes.AREA, areaSource, collect)(Area);


// WEBPACK FOOTER //
// ./src/components/partials/areas/Area.js